export default __webpack_public_path__ + "infoThirdPart.8f54395.png";